import React from 'react'
const OfferLoader = () => {
    return (
        <div className="offerloader"></div>
    )
}

export default OfferLoader